export var BOOKING_ENGINE_OPTIONAL_FIELDS = [
    {
        key: 'streetName',
        value: 'Street Name',
        type: 'text'
    },
    {
        key: 'city',
        value: 'City',
        type: 'text'
    },
    {
        key: 'zipCode',
        value: 'Zip Code',
        type: 'text'
    },
    {
        key: 'country',
        value: 'Country',
        type: 'country-selector'
    }
];
export var PaymentRequirement;
(function (PaymentRequirement) {
    PaymentRequirement["CARD"] = "CARD";
    PaymentRequirement["PREAUTHORIZE"] = "PREAUTHORIZE";
    PaymentRequirement["UPFRONT_PAYMENT"] = "UPFRONT_PAYMENT";
})(PaymentRequirement || (PaymentRequirement = {}));
export var TIMESLOT_DURATION_MINUTES = [15, 30, 60];
// The first 48 hours
export var EARLIEST_BOOKABLE_SLOT_FROM_NOW_IN_HOURS = Array.from({ length: 49 }, function (_, i) { return i; });
